import {isEmpty} from 'lodash';
import {useLintSgfMutation} from '@api';
import {useEffect} from 'react';
import {Alert} from '@goproblems/ui';
import {useTranslation} from 'react-i18next';

const SERVERITY_MAP: any = {
    error: 'danger',
    warning: 'warning',
    info: 'info',
    success: 'success',
};

export const SgfLinter = ({
    sgf,
    ...props
}: {
    sgf: string;
    [key: string]: any;
}) => {
    const {t} = useTranslation();
    const [lintSgf, {data: lintsResponse}] = useLintSgfMutation();

    useEffect(() => {
        if (isEmpty(sgf)) return;
        async function fetchData() {
            try {
                void lintSgf({sgf}).unwrap();
            } catch (error) {
                console.log(error);
                console.error('lint failed');
            }
        }
        void fetchData();
    }, [sgf, lintSgf]);

    return (
        <div {...props}>
            {lintsResponse?.entries.length === 0 && (
                <Alert variant="success" className="mb-2">
                    <p>{t('problem.no_sgf_lint_issues')}</p>
                </Alert>
            )}
            {lintsResponse?.entries.map((lint, index) => (
                <Alert
                    key={index}
                    variant={SERVERITY_MAP[lint.severity] || 'info'}
                    className={
                        lint.severity === 'warning'
                            ? 'text-sm mb-2 sgf-linter-warning'
                            : 'text-sm mb-2'
                    }>
                    <span className="font-bold">{lint.issue}!</span>{' '}
                    <span>{lint.message}</span>
                </Alert>
            ))}
        </div>
    );
};
